import React from 'react';
import styles from '@/styles/components/models-gallery/SearchBarSkeleton.module.css';

interface SearchBarSkeletonProps {
  className?: string;
}

const SearchBarSkeleton: React.FC<SearchBarSkeletonProps> = ({ className }) => {
  return (
    <div 
      className={`${styles.searchBarSkeleton} ${className || ''}`}
      role="status"
      aria-label="Loading search bar"
    >
      <div className={`${styles.skeleton} ${styles.searchInput}`} />
    </div>
  );
};

export default SearchBarSkeleton;